import Swiper from 'swiper/bundle';

export const servicesSlider = () => {
  //hero slider
  const servicesSliderEl = '.icon-list.carousel';

  $(servicesSliderEl)
    .addClass('swiper')
    .append('<div class="swiper-scrollbar">')
    .find('.wp-block-group__inner-container')
    .addClass('swiper-wrapper')
    .find('.icon-list-item')
    .addClass('swiper-slide');

  $(servicesSliderEl).find('.swiper').append('<div class="swiper-pagination">');

  new Swiper(servicesSliderEl, {
    //loop: true,
    speed: 400,
    slidesPerView: 'auto',
    spaceBetween: 60,
    //spaceBetween: 4,
    // autoplay: {
    //   delay: 4000,
    //   disableOnInteraction: true,
    // },
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev',
    // },
    freeMode: {
      enabled: true,
      sticky: false,
    },
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
    },
    // mousewheelReleaseOnEdges: true,

    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
      draggable: true,
    },
  });

  // $(heroSliderEl)
  //   .addClass('swiper')
  //   .append('<div class="swiper-pagination">')
  //   .append('<div class="swiper-button-prev">')
  //   .append('<div class="swiper-button-next">')
  //   .find('.wp-block-group__inner-container')
  //   .addClass('swiper-wrapper')
  //   .find('.wp-block-cover')
  //   .addClass('swiper-slide');
};
